import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // หรือ path ของคุณ

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!window.crypto) {
  window.crypto = {};
}

if (!window.crypto.randomUUID) {
  window.crypto.randomUUID = function () {
    return Math.random().toString(36).substring(2, 15);
  };
}

root.render(<App />);